export const ISSUES_FOR_DRESSING_REQUEST = "ISSUES_FOR_DRESSING_REQUEST";
export const ISSUES_FOR_DRESSING_SUCCESS = "ISSUES_FOR_DRESSING_SUCCESS";
export const ISSUES_FOR_DRESSING_FAILED = "ISSUES_FOR_DRESSING_FAILED";